// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wyfY","footer":"styles_footer__3jacg"};